module.exports = __webpack_public_path__ + "img/cda4f9f.png";